import EditIcon from '@mui/icons-material/Edit';

import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
} from '@mui/material';
import { FieldWithAction } from '@/components/FieldWithAction';
import { useState, useCallback } from 'react';
import {
  useRecordContext,
  Edit,
  SimpleForm,
  Toolbar,
  SaveButton,
  useRefresh,
  SelectInput,
  Labeled,
} from 'react-admin';

export const StripeSpecialSubscription = () => {
  const record = useRecordContext();

  const [dialogOpen, setDialogOpen] = useState(false);

  const onOpenDialog = () => {
    setDialogOpen(true);
  };

  const refresh = useRefresh();

  const onCloseDialog = useCallback(() => {
    setDialogOpen(false);
    refresh();
  }, [refresh]);

  return (
    <>
      <Labeled label="Stripe Subscription Type">
        <FieldWithAction
          value={record.availableSpecialSubscription || null}
          emptyText="Not set"
          maxWidth="300px"
          showActionOnHover={false}
          action={
            <IconButton
              onClick={onOpenDialog}
              size="small"
              color="primary"
              sx={{ padding: '4px' }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          }
        />
      </Labeled>
      <Dialog open={dialogOpen} onClose={onCloseDialog}>
        <DialogTitle>Set Stripe Subscription Type</DialogTitle>
        <Edit
          mutationMode="pessimistic"
          mutationOptions={{ onSuccess: onCloseDialog }}
          resource="therapists"
          queryOptions={{ meta: { raw: true } }}
          id={record.id}
        >
          <SimpleForm
            toolbar={
              <Toolbar>
                <DialogActions>
                  <Button
                    color="secondary"
                    onClick={onCloseDialog}
                    type="button"
                  >
                    Cancel
                  </Button>
                  <SaveButton
                    resource="therapists"
                    label="Set Stripe Subscription Type"
                    color="primary"
                    type="button"
                    transform={rec => ({
                      availableSpecialSubscription:
                        rec.availableSpecialSubscription,
                    })}
                    mutationOptions={{
                      onSuccess: () => {
                        onCloseDialog();
                        refresh();
                      },
                    }}
                  />
                </DialogActions>
              </Toolbar>
            }
          >
            <SelectInput
              fullWidth
              autoFocus
              source="availableSpecialSubscription"
              label="Stripe Subscription Type"
              choices={[
                { id: 'standard', name: 'Standard - Monthly' },
                { id: 'student', name: 'Student - Monthly' },
                { id: 'ambassador', name: 'Ambassador - Monthly' },
                { id: 'standard-yearly', name: 'Standard - Yearly' },
                { id: 'student-yearly', name: 'Student - Yearly' },
                {
                  id: 'ambassador-yearly',
                  name: 'Ambassador - Yearly',
                },
              ]}
              optionText="name"
              optionValue="id"
            />
          </SimpleForm>
        </Edit>
      </Dialog>
    </>
  );
};
